export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de": {
        "answer_with_probability": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["„Das ist zu ", _interpolate(_named("percentage")), "% ", _interpolate(_named("object")), "“"])},
        "answer_without_probability": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["„Das ist ", _interpolate(_named("object")), "“"])}
      },
      "en": {
        "answer_with_probability": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["\"This is ", _interpolate(_named("object")), " with a probability of ", _interpolate(_named("percentage")), "%\""])},
        "answer_without_probability": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["\"This is ", _interpolate(_named("object")), "\""])}
      }
    }
  })
}
